import { useEffect, useState } from "react";
import { getInjectionStartedTeamScenarios } from "../api/services/platformAdminService";

export function useInjectionRuns() {
  const [runs, setRuns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let isActive = true;
    const fetchRuns = async () => {
      try {
        const data = await getInjectionStartedTeamScenarios();
        if (isActive) setRuns(data?.runs || []);
      } catch (err) {
        if (isActive) setLoadError(err?.message || "Failed to load runs.");
      } finally {
        if (isActive) setIsLoading(false);
      }
    };
    fetchRuns();
    return () => {
      isActive = false;
    };
  }, []);

  return { runs, setRuns, isLoading, loadError };
}

// Runs come back flat; the overview shows one card per scenario.
export function groupRunsByScenario(runs) {
  const groups = new Map();
  runs.forEach((run) => {
    const group = groups.get(run.scenario_id) || {
      scenarioId: run.scenario_id,
      scenario: run.scenario,
      runs: [],
    };
    group.runs.push(run);
    groups.set(run.scenario_id, group);
  });
  return Array.from(groups.values());
}
